module.exports = __webpack_public_path__ + "static/jergal-symbol-DND3_FnP-72d8c8f9d6703e9f65025ff0cfbb952b.webp";